module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_5_Haber@2x.45522a9cb50dfc954437e5147e9cbc1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_5_Haber@2x.png
// module id = 752
// module chunks = 0